import { debounce } from 'lodash';
import React, { useCallback, useEffect, useMemo } from 'react';

import convertDayRangeToTimeRange from '../../../utils/timeRangeMagic';
import { DayRange, FontSize, FormWrapper, NumberField, Select, Slider, Switch, Text } from '../../../WidgetConfiguratorComponents/FormGroups';

const BasicSettingsConfigurator = ({ viewblockState, setViewblockState }) => {
    const onSettingsChange = useCallback(
        (key) => (value) => {
            setViewblockState((prev) => ({
                ...prev,
                settings: {
                    ...prev.settings,
                    [key]: value,
                },
            }));
        },
        [setViewblockState]
    );

    const setViewblockStateDebounced = useMemo(() => debounce(setViewblockState, 500), []);
    const dayRangeMin = viewblockState.settings.dayRange.min - 1;
    const dayRangeMax = viewblockState.settings.dayRange.max + 1;
    const timeRange = convertDayRangeToTimeRange({ min: dayRangeMin, max: dayRangeMax });

    useEffect(() => {
        setViewblockStateDebounced((prev) => ({
            ...prev,
            databilities: prev.databilities.map(({ fromTime, toTime, ...datability }) => ({
                ...datability,
                timeRange,
            })),
        }));
    }, [timeRange]);

    const onDayRangeChange = useCallback(
        (value) => {
            const dayRange = { min: value[0], max: value[1] };

            onSettingsChange('dayRange')(dayRange);
        },
        [onSettingsChange]
    );

    return (
        <FormWrapper>
            <DayRange dayRange={viewblockState.settings.dayRange} onChange={onDayRangeChange} />
            <FontSize fontSize={viewblockState.settings.fontSize} onChange={onSettingsChange('fontSize')} />
            <Slider label='Header padding:' value={viewblockState.settings.headerPadding} min={0} max={50} onChange={onSettingsChange('headerPadding')} />
            <Text label='Title' value={viewblockState.settings.title} onChange={onSettingsChange('title')} />
            <Select
                label='Orientation'
                value={viewblockState.settings.orientation}
                values={['horizontal', 'vertical']}
                onChange={onSettingsChange('orientation')}
            />
            <Switch label='Display table heading' value={viewblockState.settings.displayTableHeading} onChange={onSettingsChange('displayTableHeading')} />
            <Switch
                disabled={viewblockState.settings.orientation === 'vertical'}
                label='Use fixed offset'
                value={viewblockState.settings.useFixedOffset}
                onChange={onSettingsChange('useFixedOffset')}
            />
            {viewblockState.settings.useFixedOffset && viewblockState.settings.orientation === 'horizontal' && (
                <NumberField
                    label='Left offset'
                    value={viewblockState.settings.offsetLeft}
                    onChange={(newOffsetLeft) => onSettingsChange('offsetLeft')(Math.round(newOffsetLeft))}
                    step={1}
                />
            )}

            {/* <Switch label='Show values' value={viewblockState.settings.showValues} onChange={onSettingsChange('showValues')}/> This option does not work with DataTable component */}
            <Switch label='Display group labels' value={viewblockState.settings.showGroupLabels} onChange={onSettingsChange('showGroupLabels')} />
            <Switch label='Rotate labels' value={viewblockState.settings.rotateVerticalLabels} onChange={onSettingsChange('rotateVerticalLabels')} />
            <Switch label='Divide the days to the intervals' value={viewblockState.settings.binning} onChange={onSettingsChange('binning')} />
            {viewblockState.settings.binning && (
                <Select
                    label='Number of intervals'
                    value={viewblockState.settings.bins}
                    onChange={(bins) => onSettingsChange('bins')(Math.round(bins))}
                    values={[1, 2, 3, 4, 6, 8, 12, 24]}
                />
            )}
        </FormWrapper>
    );
};

export default BasicSettingsConfigurator;
